import ownerRoutes from './owner'
import publicRoutes from './user'

export default [
  {
    path: '/',
    component: () => import('@/layouts/main/Main.vue'),
    children:[
      ...ownerRoutes,
      ...publicRoutes
    ]
  }
]